import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styles: [],
})
export class AppComponent {
  constructor(private translate: TranslateService) {
    // Set default language
    const savedLang = localStorage.getItem('preferredLanguage') || 'en';
    this.translate.setDefaultLang('en');
    this.translate.use(savedLang);
  }
}
